import { render, staticRenderFns } from "./ParcelsBypassOrder.vue?vue&type=template&id=0a80c746&scoped=true&"
import script from "./ParcelsBypassOrder.vue?vue&type=script&lang=js&"
export * from "./ParcelsBypassOrder.vue?vue&type=script&lang=js&"
import style0 from "./ParcelsBypassOrder.vue?vue&type=style&index=0&id=0a80c746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80c746",
  null
  
)

export default component.exports